const refs = 'errors'
export default [
    
    { 
        path: '/forbidden',
        name: 'forbidden', 
        component: () => import('@/views/'+refs+'/Forbidden.vue')
    },
    { 
        path: '*',
        redirect: '/404',
        hidden: true,
    },
    { 
        path: '/404',
        name: '404',
        component: () => import('@/views/'+refs+'/NotFound.vue'),
        meta: { hideComponents: true }

    }
]
